<template>
    <div id="getCode">
        <div class="logo"></div>
        <h6>1万个有道词典VIP</h6>
        <h5>限时赠送</h5>
        <div class="desc">VIP用户新世纪日汉双解大辞典免费用</div>
        <div class="butten_list">
            <div :class="canGetOneMounthVip ? 'one_mouth_vip' : 'one_mouth_vip_no'"  @click="getOneMounthVip"></div>
            <div :class="canGetSixMounthVip ? 'six_mouth_vip' : 'six_mouth_vip_no'" @click="getSixMounthVip"></div>
        </div>
        <p><span>/</span>VIP兑换码<span>/</span></p>
        <div class="code" id="code" unselectable="on" ref="code" v-html="code"></div>
        <div class="sign" v-show="!success"></div>
        <div class="prompt" v-show="success"></div>
        <prompt :prompt="prompt" :share="share" :save="save" :getSuccess="getSuccess" @closed="closed"/>
        <div class="container">
            <a class="open_dict" href="http://a.app.qq.com/o/simple.jsp?pkgname=com.youdao.dict&ckey=CK1407861672048">打开有道词典</a>
        </div>
        <login :showLogin="showLogin" @isLogin="isLogin"/>
    </div>
</template>

<script>
    import Clipboard from 'clipboard'
    import { initShareData, login, getCoupon, setStorage, getStorage, getParameter, changeURLArg } from './../libs/util.js'
    import Login from './Login'
    import Prompt from './Prompt'
    import jsonp from 'jsonp'
    export default {
        name: 'GetCode',
        data () {
            return {
                isShowCode: false,
                code: '＊＊＊＊',
                canGet: 'canGet',
                noGet: 'noGet',
                couponType: '',
                showLogin: false,
                success: false,
                save: false,
                getSuccess: false,
                share: false,
                prompt: false,
                canGetSixMounthVip: true,
                canGetOneMounthVip: true
            }
        },
        props: {
            isCanGet: '',
            signId: ''
        },
        mounted () {
            let oldCode = getStorage('code')
            if (oldCode != undefined) {
                this.isShowCode = true
                this.code = oldCode
            }
            this.signId = getParameter('signId')
            document.getElementsByClassName('mask')[0].addEventListener('touchmove', function(event) {
                event.preventDefault()
            }, false)
            document.getElementsByClassName('mask')[1].addEventListener('touchmove', function(event) {
                event.preventDefault()
            }, false)
            
        },
        components: {
            Login,
            Prompt
        },
        watch: {
            code: function (val) {
                if (val != '＊＊＊＊') {
                    this.success = true
                }
            }
        },
        methods: {
            getOneMounthVip: function () {
                let that = this
                this.couponType = '1'
                let url
                window.ydk.isLogin({
                    success: function (res) {
                        if (!res.isLogin) {
                            that.showLogin = true
                        } else {
                            jsonp('http://ns014x.corp.youdao.com:12008/webutil/v2/dictVIP/getEncodedUserId', function (err, data) {
                                let url
                                let signId = data.result.signId
                                if (!ydk.isYD) {
                                    url = changeURLArg(window.location.href, 'signId', signId)
                                } else {
                                    url = changeURLArg('http://c.youdao.com/test/oxford-activity/index.html', 'signId', signId)
                                }
                                initShareData(url, true)
                            })
                            if ( that.signId == '' ) {
                                url = `http://ns014x.corp.youdao.com:12008/webutil/v2/dictVIP/getCoupon?couponType=${that.couponType}`
                            } else {
                                url = `http://ns014x.corp.youdao.com:12008/webutil/v2/dictVIP/getCoupon?couponType=${that.couponType}&signId=${that.signId}`
                            }
                            jsonp(url, function (err, data) {
                                if (data.code != 503) {
                                    setStorage('code',that.code)
                                    that.success = true
                                    that.canGetOneMounthVip = false
                                    that.code = data.data.coupon
                                    // that.prompt = true
                                    // that.share = false
                                    // that.getSuccess = true
                                    // that.save = false
                                } else {
                                    that.canGetOneMounthVip = false
                                    alert(data.reason)
                                }
                            })
                        }
                    }
                })
                
            },
            getSixMounthVip: function () {
                let that= this
                let url = `http://ns014x.corp.youdao.com:12008/webutil/v2/dictVIP/halfYear?signId=${this.signId}`
                ydk.isLogin({
                    success: function (res) {
                        if (!res.isLogin) {
                            that.showLogin = true
                        } else {
                            jsonp('http://ns014x.corp.youdao.com:12008/webutil/v2/dictVIP/getEncodedUserId', function (err, data) {
                                let url
                                let signId = data.result.signId
                                if (!ydk.isYD) {
                                    url = changeURLArg(window.location.href, 'signId', signId)
                                } else {
                                    url = changeURLArg('http://c.youdao.com/test/oxford-activity/index.html', 'signId', signId)
                                }
                                initShareData(url, true)
                            })
                            jsonp(url, function (err, data) {
                                if (data.result.halfYear) {
                                    that.isCanGet = false
                                    that.couponType = '6'
                                    that.showCoupon()
                                } else {
                                    if (that.$parent.data.length < 6) {
                                        that.prompt = true
                                        that.share = true
                                        that.getSuccess = false
                                        that.save = false
                                        that.canGetSixMounthVip = false
                                    } else {
                                        that.canGetSixMounthVip = false
                                        alert("您已经领取过了")
                                    }
                                }
                            })
                        }
                    }
                })
                
            },
            showCoupon: function (phone) {
                let that = this
                let url
                if ( this.signId == '' ) {
                    url = `http://ns014x.corp.youdao.com:12008/webutil/v2/dictVIP/getCoupon?couponType=${this.couponType}`
                } else {
                    url = `http://ns014x.corp.youdao.com:12008/webutil/v2/dictVIP/getCoupon?couponType=${this.couponType}&signId=${this.signId}`
                }
                jsonp( url, function (err, data) {
                    that.code = data.data.coupon
                    that.prompt = true
                    that.share = false
                    that.getSuccess = false
                    that.save = true
                    setStorage('code',that.code)
                    that.success = true
                })
            },
            isLogin: function () {
                this.showLogin = false
            },
            closed: function () {
                this.prompt = false
            }
        }
    }
</script>

<style>
    #getCode {
        width: 100%;
        margin: -1.5rem auto 0.8rem;
        overflow: hidden;
    }
    .logo {
        width: 1.06rem;
        height: 0.48rem;
        background-image: url(http://shared.youdao.com/dict/market/oxford-activity/imgs/logo.png);
        background-size: 100% 100%;
        margin: 0 auto 0.66rem;
    }
    h6 {
        font-size: 0.48rem;
        text-align: center;
        font-weight: 500;
        display: block;
        margin:0 0 0.36rem 0;
    }
    h5 {
        font-size: 0.51rem;
        text-align: center;
        font-weight: 900;
        color: #3f3f3f;
        display: block;
        margin-bottom: 0.45rem;
    }
    .desc {
        display: block;
        font-size: 0.3rem;
        text-align: center;
        margin-bottom: 0.7rem;
    }
    .butten_list {
        width: 5.31rem;
        margin: 0 auto 0.66rem;
        overflow: hidden;
    }
    .one_mouth_vip, .six_mouth_vip, .six_mouth_vip_no, .one_mouth_vip_no{
        width: 2.3rem;
        height: 2.86rem;
        border: 0.04rem solid #c19b64;
        position: relative;
    }
    .one_mouth_vip{
        float: left;
        background-image: url(http://shared.youdao.com/dict/market/oxford-activity/imgs/vip.png);
        background-size: 100% 100%;
    }
    .one_mouth_vip_no {
        float: left;
        background-image: url(http://shared.youdao.com/dict/market/oxford-activity/imgs/vip2.png);
        background-size: 100% 100%;
    }
    .six_mouth_vip{
        float: right;
        background-image: url(http://shared.youdao.com/dict/market/oxford-activity/imgs/vipg1.png);
        background-size: 100% 100%;
    }
    .six_mouth_vip_no {
        float: right;
        background-image: url(http://shared.youdao.com/dict/market/oxford-activity/imgs/vipg2.png);
        background-size: 100% 100%;
    }
    .sign {
        width: 3.04rem;
        height: 0.3rem;
        background-image: url(http://shared.youdao.com/dict/market/oxford-activity/imgs/sign.png);
        background-size: 100% 100%;
        margin: 0 auto;
    }
    .canGet {
        color: #c6924d;
    }
    .canGet, .noGet {
        background-color: #ffffff;
        margin-left: 0.23rem;
        margin-top: 2.17rem; 
        width: 1.85rem;
        height: 0.4rem;
        background-size: 100% 100%;
        border-radius: 0.3rem;
        font-size: 0.20rem;
        line-height: 0.4rem;
        text-align: center;
    }

    .noGet{
        color: #000;
    }

    p {
        width: 100%;
        text-align: center;
        color: #3f3f3f;
        font-size: 0.32rem;
        line-height: 0.32rem;
        font-weight: 700;
    }
    p span {
        display: inline-block;
        color: #c7a472;
        font-size: 0.32rem;
        line-height: 0.36rem;
        margin: 0 0.6rem;
    }
    .code {
        display: block;
        width: 2.66rem;
        height: 0.6rem;
        line-height: 0.52rem;
        border: 0.03rem solid #bf975e;
        color: #000000;
        margin: 0.25rem auto 0.4rem;
        box-sizing: border-box;
        border-radius: 0.05rem;
        background-color: transparent;
        text-shadow:0 0 0 red;
        text-align: center;
        font-size: 0.36rem;
        vertical-align: text-bottom;
    }
    #getCode .container {
        width: 100%;
        height: 3.2rem;
        overflow: hidden;
        background-image: url(http://shared.youdao.com/dict/market/oxford-activity/imgs/openbg.png);
        background-size: 100%;
    }
    .open_dict {
        width: 3.4rem;
        height: 0.68rem;
        border-radius: 0.4rem;
        display: block;
        margin: 0.78rem auto 0.68rem;
        background-color: #c6934c;
        text-align: center;
        color: #ffffff;
        line-height: 0.68rem;
        font-size: 0.33rem;
        font-weight: 700;
    }
    .prompt {
        width: 5.56rem;
        height: 0.94rem;
        background-image: url(http://shared.youdao.com/dict/market/oxford-activity/imgs/success.png);
        background-size: 100% 100%;
        margin: 0 auto;
    }
</style>



// WEBPACK FOOTER //
// GetCode.vue?04cb5b9a